<template>
  <div class="w-100">
    <label v-if="label" class="input-label">{{ label }}</label>
    <label
      v-if="!value"
      class="form-control position-relative"
      :class="{ 'was-Invalidated': error }"
    >
      <i class="fas fa-file input-icon" />
      <label class="file-select">
        <div class="select-button">
          <span>Seleccionar</span>
        </div>
        <input
          :id="`${id}-txtfile`"
          type="file"
          :accept="accept"
          @change="handleFileChange"
        />
      </label>
    </label>
    <div v-if="value" class="w-100">
      <div class="d-flex justify-content-start align-items-center">
        <div class="d-flex justify-content-start align-items-center">
          <label class="circle-green" />
          <label class="ml-2 mb-0 mr-2">{{ value.name }}</label>
        </div>
        <div>
          <button
            :id="`${id}-btnremove`"
            type="button"
            class="btn btn-block btn-outline-danger"
            @click="removeFile"
          >
            <i class="fas fa-times-circle" />
            &nbsp;&nbsp;Remover
          </button>
        </div>
      </div>
    </div>
    <Error v-if="error" variant="no-border" :message="customErrorMsg" />
  </div>
</template>

<style scoped>
.form-control {
  border: 1px solid #c5cdcf;
  height: 40px;
  cursor: pointer;
}
.input-icon {
  color: #727272;
}
.file-select {
  position: absolute;
  top: 0;
  right: 0;
  margin: 0;
  height: 100%;
}
.file-select > .select-button {
  background-color: #2db782;
  width: fit-content;
  height: 100%;
  text-align: center;
  color: white;
  font-size: 16px;
  padding: 7px 35px;
  font-weight: lighter;
  border-radius: 0px 4px 4px 0px;
  cursor: pointer;
}
.btn.btn-block.btn-outline-danger {
  color: #c9545e;
  border: 1px solid #c9545e;
  border-radius: 32px;
  height: 32px;
  padding: 0;
  font-weight: 400;
  width: fit-content;
  padding: 0 15px;
  padding-bottom: 0.4rem;
}
.btn.btn-block.btn-outline-danger:hover {
  background-color: #c9545e;
  color: white;
}
.file-select > input[type='file'] {
  display: none;
}

span.invalid:not(input) {
  color: #e85c5c;
}
.circle-green {
  border-radius: 100%;
  background-color: #2db782;
  height: 12px;
  width: 12px;
  margin: 0;
}
.input-label {
  height: 19px;
  text-align: left;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: #11291b;
  line-height: 19px;
}
</style>

<script>
import Error from '@/components/common/Error';

export default {
  name: 'CustomFileUpload',
  meta: {
    description: 'Componente personalizado de carga de archivos',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  components: {
    Error,
  },
  props: {
    id: {
      type: String,
      default: 'custom-upload-file',
      meta: {
        description: 'Id del Componente CustomFileUpload',
        example: 'IdCustomFileUpload',
      },
    },
    label: {
      type: String,
      default: '',
      meta: {
        description: 'Control para mostrar texto',
        example: 'Texto requerido',
      },
    },
    placeholder: {
      type: String,
      default: '',
      meta: {
        description: 'Texto de referencia para el CustomFileUpload',
        example: 'Texto requerido',
      },
    },
    value: {
      type: File,
      default: '',
      meta: {
        description: 'Parámetro de entrada del CustomFileUpload',
        example: '',
      },
    },
    accept: {
      type: String,
      default: '*',
      meta: {
        description: 'Control para aceptar archivos',
        example: 'Texto requerido',
      },
    },
    multiple: {
      type: Boolean,
      default: false,
      meta: {
        description: 'Estable selección múltiple',
        example: 'true',
      },
    },
    required: {
      type: String,
      default: function() {
        return '';
      },
      meta: {
        description: 'Estado requerido',
        example: 'Texto requerido',
      },
    },
    error: {
      type: String,
      default: '',
      meta: {
        description: 'Estado Error',
        example: 'Texto requerido',
      },
    },
    customErrorMsg: {
      type: String,
      default: function() {
        return this.error;
      },
      meta: {
        description: 'Mensaje de error encontrado',
        example: 'Texto requerido',
      },
    },
  },
  methods: {
    handleFileChange: function(e) {
      if (e.target.files && e.target.files.length > 0) {
        this.$emit('input', e.target.files[0]);
      }
    },
    removeFile: function(e) {
      e.preventDefault();
      this.$emit('input', null);
    },
  },
  computed: {},
};
</script>
